var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.82333 3.82902L6.27722 0.509066C6.1681 0.274769 5.8319 0.274769 5.72278 0.509066L4.17667 3.82902C4.1322 3.92451 4.04083 3.99025 3.9354 4.00264L0.269711 4.43311C0.0110151 4.46349 -0.092878 4.78019 0.0983826 4.95537L2.80852 7.43769C2.88647 7.50908 2.92137 7.61547 2.90068 7.71861L2.18127 11.3046C2.1305 11.5577 2.4025 11.7534 2.62982 11.6274L5.85089 9.84159C5.94353 9.79022 6.05647 9.79022 6.14911 9.84159L9.37018 11.6274C9.5975 11.7534 9.8695 11.5577 9.81873 11.3046L9.09932 7.71861C9.07863 7.61547 9.11353 7.50908 9.19148 7.43769L11.9016 4.95537C12.0929 4.78019 11.989 4.46349 11.7303 4.43311L8.0646 4.00264C7.95917 3.99025 7.8678 3.92451 7.82333 3.82902Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.26341c0129810e3744876482907fe369.svg";
export { ForwardRef as ReactComponent };